/**
 * @desc 仪表盘图
 * @author caoyx
 * @param 必传：exponent { number } 指数（范围：[0,1]）
 * @example <Gauge exponent={0.9} />
 */
import './gauge.scss';
import React from 'react';
import cns from 'classnames';
import { numberFixed } from '../../../utils/formatter';
import pointerPNG from '../../../images/pointer.png';

export default function Gauge({ exponent = 0, className = '', ...other }) {
    exponent = numberFixed(exponent);
    const angleRotate = `rotate(${exponent * 180 - 88}deg)`;
    const angleStyle = {
        transform: angleRotate,
        msTransform: angleRotate,
        WebkitTransform: angleRotate,
        MozTransform: angleRotate,
        OTransform: angleRotate
    };
    let phase = 0;

    // 计算阶段
    if (exponent > 0.8) {
        phase = 4;
    } else if (exponent > 0.6){
        phase = 3;
    } else if (exponent > 0.4){
        phase = 2;
    } else if (exponent > 0.2){
        phase = 1;
    } else {
        phase = 0;
    }

    const colorStyle = { color: ['#8eb779', '#f9f282', '#efa784', '#ed726c', '#d73128'][phase] };
    const evaluation = ['优', '良', '中', '较差', '差'][phase];

    return (
        <div {...other} className={cns('score-gauge', className)}>
            <span className="number zero">0</span>
            <span className="number one">1</span>
            <img className="pointer" src={pointerPNG} style={angleStyle} />
            <span className="exponent" style={colorStyle}>
                {exponent}
            </span>
            <span className="evaluation" style={colorStyle}>
                {evaluation}
            </span>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/gauge/Gauge.jsx